import { render } from "./UserCustomsHouseListsModal.vue?vue&type=template&id=08ac01c8&ts=true"
import script from "./UserCustomsHouseListsModal.vue?vue&type=script&lang=ts"
export * from "./UserCustomsHouseListsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__